import axios from 'axios'
import { toastr } from 'react-redux-toastr'
import { URL } from '../../assets/js/constants'

export function carregarPerguntasPorNegocio(data) {
    return {
        type: 'PERGUNTAS_NEGOCIO_FETCHED',
        payload: data
    }
}

export function getPerguntasPorNegocio(values) {
    const { idNegocio, page, linesPerPage, direction, orderBy } = values;
    return dispatch => {
        axios.get(`${URL}/duvidas/vendedor/page?idNegocio=${idNegocio}&page=${page}&linesPerPage=${linesPerPage}&direction=${direction}&orderBy=${orderBy}`)
            .then(resp => dispatch(carregarPerguntasPorNegocio(resp.data)))
            .catch(e => toastr.error('Erro', e.message))
    }
}